module.exports = __webpack_public_path__ + "img/social.4a4dcc90.svg";